import {
  prepareProgramAndDependentData,
  removeOrderNameForCloneProgramFlow,
} from './pre-transformers';
import {
  BundlesAndAttributesContainer,
  DemographicsContainer,
  InputFileSelectionContainer,
  OrderDetailsContainer,
  OutputLocationsContainer,
  ScoresAndAddonProductsContainer,
  OutputLayoutContainer,
} from './program-wizard';
import {
  ProgramTransformer,
  ProgramWizardConfig,
  ProgramWizardStepInfo,
} from '@/app/core/components/program-wizard';
import {
  amendSubscriberCode,
  ensureValidCloneFromProgramExists,
} from '@/app/features/products/common';
import { sequencePromiseFunctions, SSARProgram } from '@ssar-app/domain';

export const getAscendQuestWebQuestProgramWizardConfig =
  async (): Promise<ProgramWizardConfig> => {
    const preTransformer: ProgramTransformer = sequencePromiseFunctions(
      ensureValidCloneFromProgramExists,
      amendSubscriberCode,
      removeOrderNameForCloneProgramFlow,
      prepareProgramAndDependentData,
    );
    const programKeys = {
      'Order Details': ['orderDetails'],
      'Scores and Add-on Products': ['scoresAndAddonProducts'],
      Demographics: ['demographics'],
      'Attributes and Bundles': ['attributesAndBundles'],
      'Input File': ['inputFile'],
      'Output Locations': ['outputLocations'],
      'Output Layout': ['outputLayout'],
    };

    const steps: ProgramWizardStepInfo[] = [
      {
        key: programKeys['Order Details'],
        title: 'Order Details',
        description: '', // 'Enter program details',
        element: <OrderDetailsContainer keys={programKeys['Order Details']} />,
      },
      {
        key: programKeys['Scores and Add-on Products'],
        title: 'Scores and Add-On Products',
        description: '', // 'Select Scores and Add-on Products',
        element: (
          <ScoresAndAddonProductsContainer
            keys={programKeys['Scores and Add-on Products']}
          />
        ),
      },
      {
        key: programKeys['Demographics'],
        title: 'Demographics',
        description: '', // 'Select Demographics',
        element: <DemographicsContainer keys={programKeys['Demographics']} />,
      },
      {
        key: programKeys['Attributes and Bundles'],
        title: 'Attributes',
        description: '', // 'Select Attributes and Bundles',
        element: (
          <BundlesAndAttributesContainer
            keys={programKeys['Attributes and Bundles']}
          />
        ),
      },
      {
        key: programKeys['Input File'],
        title: 'Input File',
        description: '', // 'Select Input File',
        element: (
          <InputFileSelectionContainer
            keys={programKeys['Input File']}
            inputFileSelectionOptions={{
              canSelectClientFile: true,
              canSelectRemoteFile: true,
            }}
          />
        ),
      },
      {
        key: programKeys['Output Locations'],
        title: 'Output Locations',
        description: '', // 'Select Output Locations',
        element: (
          <OutputLocationsContainer keys={programKeys['Output Locations']} />
        ),
      },
      {
        key: programKeys['Output Layout'],
        title: 'Output Layout',
        description: '', // 'Select Output Layout',
        element: <OutputLayoutContainer keys={programKeys['Output Layout']} />,
      },
    ];
    const toReturn: ProgramWizardConfig = {
      steps,
      preTransformer,
      isSaveDraftsAllowed: true,
      isAutoSaveAllowed: true,
      autoSaveTimer: 30 * 1000,
    };
    return Promise.resolve(toReturn);
  };

export const getProgramName = (model: SSARProgram) => {
  return model?.orderDetails?.name || '';
};
